import {CoreMenu} from '@core/types';

export const menu: CoreMenu[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        translate: 'MENU.DASHBOARD',
        type: 'item',
        icon: 'fas fa-sign',
        url: 'dashboard',
        availableTo: ['SUPER_ADMIN', 'ADMIN', 'HEAD_COUNSELLOR', 'COUNSELLOR', 'UNIVERSITY']
    },

    {
        id: 'university',
        title: 'University',
        translate: 'MENU.UNIVERSITIES',
        type: 'item',
        icon: 'fas fa-university',
        url: 'university',
        availableTo: ['SUPER_ADMIN']
    },
    {
        id: 'course',
        title: 'Course',
        translate: 'MENU.COURSES',
        type: 'item',
        icon: 'fas fa-graduation-cap',
        url: 'course',
        availableTo: ['SUPER_ADMIN']
    },
     {
        id: 'category',
        title: 'Category',
        translate: 'MENU.CATEGORY',
        type: 'item',
        icon: 'fas fa-sliders-h',
        url: 'category',
        availableTo: ['SUPER_ADMIN']
    },
    {
        id: 'ebooks',
        title: 'E-books',
        translate: 'MENU.EBOOKS',
        type: 'item',
        icon: 'fas fa-book',
        url: 'ebooks',
        availableTo: ['SUPER_ADMIN']
    },
    {
        id: 'lectures',
        title: 'Lectures',
        translate: 'MENU.LECTURES',
        type: 'item',
        icon: 'fas fa-video',
        url: 'lectures',
        availableTo: ['SUPER_ADMIN']
    },

];
